    import React, { useEffect, useRef, useState } from 'react';
    import { useSelector, useDispatch } from 'react-redux';
    import { getMediaPath } from "app/functions";
    import ReactHtmlParser from 'react-html-parser';

    //components
    import JoinForm from './sections/join-form/join-form';
    import BreadCrumbs from '../../components/common/bread_crumbs';


    //assets
    import './client-join.scss';
    import * as routes from "../../constants/routes";
    import ImageHeader from "../../components/image-header";

    import { useGetUsersApplicationQuery } from 'redux/api/relations.api';

    function ClientJoin() {
        const joinFrom = useRef(null);

        const deviceState = useSelector(store => store.state.deviceState);
        const text = useSelector(store => store.config.Translations);

        const {data: getUsersApplicationPageData} = useGetUsersApplicationQuery();
        const [userApplicationPage, setUserApplicationPage] = useState(getUsersApplicationPageData);

        const [workplaces, setWorkplaces] = useState(false);
        const [joiningReasons, setJoiningReasons] = useState(false);
        const [joiningRoutes, setJoiningRoutes] = useState(false);

        useEffect(() => {
            if (getUsersApplicationPageData) {
                setUserApplicationPage(getUsersApplicationPageData);
                setWorkplaces(getUsersApplicationPageData.details?.body.workPlaces);
                setJoiningReasons(getUsersApplicationPageData.types);
                setJoiningRoutes(getUsersApplicationPageData.routes);
            }
        }, [getUsersApplicationPageData]);

        const scrollToForm = () => {
            let header_height = document.getElementsByTagName('header')[0]?.clientHeight;
            let scroll_top = joinFrom.current.getBoundingClientRect().top - header_height;
            window.scrollTo(0, scroll_top);
        };

        const isMobile = deviceState === 'mobile';
        
        let banner, bottomBanner = null;
        let iconsArr = [];
        if (userApplicationPage) {
            banner = isMobile ? getMediaPath(userApplicationPage.details.header.mobileImagePath) : getMediaPath(userApplicationPage.details.header.imagePath);
            bottomBanner = userApplicationPage?.details?.body?.bottomBanner && getMediaPath(userApplicationPage.details.body.bottomBanner);

            iconsArr = userApplicationPage.icons?.map((item, index) => {
                return (
                    <div className="item" key={index}>
                        <img className='icon' src={getMediaPath(item.imagePath)} alt="" />
                        <div className="number">{item.title}</div>
                        <div className="label">{item.text}</div>
                    </div>
                );
            });
        }

        return (
            <main className='client-join'>
                <ImageHeader
                    image={banner}
                    title={userApplicationPage?.details?.header?.title}
                    subtitle={userApplicationPage?.details?.header?.content}
                />

                <BreadCrumbs root={{ text: 'דף הבית', route: routes.home }} />

                {iconsArr && (
                    <section className="numbers">
                        {iconsArr}
                    </section>
                )}
                {userApplicationPage && userApplicationPage.details.body.link && userApplicationPage.details.body.header && userApplicationPage.details.body.content &&
                    <section className="video">
                        <div className='youtube-wrapper'>
                            <iframe className="iframe"
                                src={userApplicationPage.details.body.link}
                                title={userApplicationPage.details.body.header}
                                frameBorder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen />
                        </div>
                        <div className="text">
                            <h2 className="title">{userApplicationPage.details.body.header}</h2>
                            <div className="paragraph">{ReactHtmlParser(userApplicationPage.details.body.content)}</div>
                        </div>
                    </section>
                }

                <div ref={joinFrom} className='form-container'>
                    {workplaces &&
                        <JoinForm deviceState={deviceState} joiningReasons={joiningReasons} joiningRoutes={joiningRoutes} workplaces={workplaces} title={userApplicationPage?.details?.body?.formTitle} userApplicationPage={userApplicationPage} />
                    }
                </div>
                {bottomBanner && <ImageHeader
                    image={bottomBanner}
                />}
            </main>
        );
    }

    export default ClientJoin;
